import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Close, OpenInNew } from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton } from '@mui/material'

type ScreenshotEnlargeDialogProps = {
  url?: string
  alt: string
  onClose: () => void
}

export const ScreenshotEnlargeDialog: FC<ScreenshotEnlargeDialogProps> = ({ url, alt, onClose }) => {
  const { t } = useTranslation()
  return (
    <Dialog open={!!url} onClose={onClose} maxWidth="lg">
      <IconButton aria-label={t('internal-common:close')} onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, bgcolor: 'background.paper' }}>
        <Close />
      </IconButton>
      <DialogContent sx={{ p: 0 }}>
        {url && <Box component="img" src={url} alt={alt} sx={{ display: 'block', maxWidth: '100%', maxHeight: '85vh', objectFit: 'contain' }} />}
      </DialogContent>
      <DialogActions>
        <Button startIcon={<OpenInNew />} href={url ?? ''} target="_blank" rel="noopener noreferrer">
          {t('internal-analysts:implementation_open_image')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
